import React from 'react';
import styled from 'styled-components';

const Button = styled.button`
  
  background: var(--bg-panel);
  border: none;
  color: var(--text-secondary);
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  z-index: 1;
  &.active {
    background: var(--brand-blue) !important;
  }
  &:hover {
    color: var(--text-primary);
    background: var(--bg-hover);
  }

  ${props => props.active && `
    color: var(--text-primary);
    background: var(--bg-hover);
  `}
`;

const IconButton = ({ icon, onChange, size = 16, active = false, style = {} }) => {
  const handleClick = () => {
    if (onChange) {
      onChange();
    }
  };

  return (
    <Button className={`icon-button${active ? ' active' : ''}`} onClick={handleClick} style={style}>
      {React.cloneElement(icon, { size })}
    </Button>
  );
};

export default IconButton; 